import React from 'react';
import { ArticleLayout } from '../../components/ArticleLayout';

export const HtmlParsingArticle: React.FC = () => {
    return (
        <ArticleLayout
            title="Handling HTML Tags in Excel Translation"
            subtitle="Don't let broken tags ruin your localized website or app."
        >
            <h3>The Hidden Danger of HTML in Excel</h3>
            <p>
                Content Management Systems (CMS) often export content to Excel with HTML tags embedded (e.g., <code>&lt;b&gt;Bold&lt;/b&gt;</code> or <code>&lt;a href="..."&gt;Link&lt;/a&gt;</code>).
                If a translator accidentally deletes a bracket or translates a class name, your website could break.
            </p>

            <h3>Protecting Tags</h3>
            <p>
                Our converter parses the HTML inside your Excel cells. It converts these tags into XLIFF "inline codes".
                In the CAT tool, the translator sees these as purple tags that can be moved but not edited.
                This guarantees that the HTML structure remains intact in the translated file.
            </p>

            <h3>Supported Tags</h3>
            <p>
                We support standard HTML5 tags. You can also configure custom regex patterns to protect non-standard placeholders
                (like <code>%s</code>, <code>{'{1}'}</code>, or <code>{'{variable}'}</code>) ensuring that your software variables are safe.
            </p>
        </ArticleLayout>
    );
};
